/* eslint-disable react/no-unescaped-entities */

import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import TextLink from 'components/TextLink';
import Alert, { AlertTypes } from 'components/Alert';
var ReplaceButton = function ReplaceButton(_ref) {
  var onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(TextLink, {
    onClick: onClick,
    as: "button"
  }, children);
};
var DeleteButton = function DeleteButton(_ref2) {
  var onClick = _ref2.onClick,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(TextLink, {
    onClick: onClick,
    as: "button"
  }, children);
};
var ProcessingAlert = function ProcessingAlert(_ref3) {
  var isEditMode = _ref3.isEditMode,
    fileName = _ref3.fileName,
    onReplace = _ref3.onReplace,
    onDelete = _ref3.onDelete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Alert, {
    type: AlertTypes.FAIL
  }, isEditMode ? /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "alert_edit_asset_processing_error_replace",
    name: fileName
  }, "There was an error when processing the file \"", fileName, "\". Please", ' ', /*#__PURE__*/React.createElement(ReplaceButton, {
    onClick: onReplace
  }, "upload a new file"), ".") : /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "alert_asset_processing_error_replace_or_delete",
    name: fileName
  }, "There was an error when processing the file \"", fileName, "\". Please", ' ', /*#__PURE__*/React.createElement(ReplaceButton, {
    onClick: onReplace
  }, "upload a new file"), "or", /*#__PURE__*/React.createElement(DeleteButton, {
    onClick: onDelete
  }, "delete the asset"), "."));
};
export default ProcessingAlert;